import { cookiesService } from '@libs/utils/cookies'
import { atom, useAtom } from 'jotai'

import type { AuthState } from './AuthState.types'

export const authStateAtom = atom<AuthState>({
  accessTokenExpiresAt: cookiesService.readAccessTokenExpiresAt(),
  accountId: cookiesService.readAccountId(),
  userId: cookiesService.readUserId(),
  isAccountCreationInProgress: cookiesService.readIsAccountCreationInProgress()
})

export const useAuthStateAtom = () => {
  const [authState, updateAuthState] = useAtom(authStateAtom)
  return {
    authState: authState as AuthState,
    updateAuthState: updateAuthState as (newState: Partial<AuthState>) => void
  }
}
